module.exports = "/v2/pages/dashboard/dist/c3b8331b5aed6f31bba051a705c284c9.svg";